// Charge le profil utilisateur une fois authentifié. Extrait de app/page.tsx (God Object).
import { useEffect, useState } from 'react'
import type { UserProfile } from '@/types/landing'

export function useProfile(sessionStatus: string) {
  const [profile, setProfile] = useState<UserProfile | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (sessionStatus !== 'authenticated') { setLoading(false); return }
    fetch('/api/profile')
      .then(r => r.json())
      .then(data => { if (!data.error) setProfile(data) })
      .catch(() => null)
      .finally(() => setLoading(false))
  }, [sessionStatus])

  return { profile, loading }
}
